'use strict';

var _ = require('lodash');
function AdjustDatesPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'AdjustDatesComponentController',
    template: require('../templates/adjust-dates-component.html'),
    scope: {
      componentTitle: '@',
      userAdjustedDates: '=',
      settings: '=',
      disabledDates: '='
    },
    link: function link($scope) {
      $scope.$watch('settings.selectedAdjustment', function (selectedAdjustment, oldSelectedAdjustment) {
        if (!selectedAdjustment || !$scope.userAdjustedDates) {
          return;
        }
        if (oldSelectedAdjustment) {
          _.set($scope, ['userAdjustedDates', oldSelectedAdjustment], _.clone($scope.adjustedDates));
        }
        $scope.adjustedDates = _.get($scope, ['userAdjustedDates', selectedAdjustment], []);
      });
      $scope.$watch('userAdjustedDates', function () {
        var fieldname = _.get($scope, 'settings.fieldName');
        if ($scope.settings.options) {
          return $scope.initialize();
        }
        if (!fieldname && !$scope.userAdjustedDates && !_.size($scope.userAdjustedDates[fieldname])) {
          return;
        }
        $scope.adjustedDates = _.get($scope, ['userAdjustedDates', fieldname], []);
      });
    }
  };
}
AdjustDatesPanelDirective.$inject = [];
module.exports = AdjustDatesPanelDirective;